import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { annulmentSZLTFailed, annulmentSZLTSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* annulmentSZLT(action) {
  try {
    const { id, values } = action.payload;
    if (!id) { throw new Error('ID not found'); }
    const url = `${BACKEND_URL}/registries/order-services/${id}/revoke`;
    const response = yield makeRequest(url, values, action, 'POST', true);
    if (response.status === NO_CONTENT) {
      yield put(annulmentSZLTSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield getBodyJson(response);
      yield put(annulmentSZLTFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(annulmentSZLTFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
